export default {
  apiBaseURL: process.env.VUE_APP_API_BASE_URL,
  vitaleSiteUrl: process.env.VUE_APP_VITALE_SITE_URL
}
